<template>
  <div>
    <flex-row wrap gap vcenter>
      <flex-cell class="cell">
        <div>
          <label>From Date</label>
          <datepicker
            :date-only="true"
            v-model="startDate"
            placeholder="Start date..."
          />
        </div>
      </flex-cell>
      <flex-cell class="cell">
        <div>
          <label>To Date</label>
          <datepicker
            :date-only="true"
            v-model="endDate"
            placeholder="End date..."
          />
        </div>
      </flex-cell>
    </flex-row>
  </div>
</template>
<script>
import Datepicker from "../form/inputs/datepicker.vue";

function checkDate(d) {
  var date = new Date(d);
  if (date instanceof Date && !isNaN(date.getTime())) {
    return date;
  }

  return;
}

export default {
  components: {
    Datepicker,
  },
  props: {
    modelValue: {
      type: Object,
    },
  },
  data() {
    return {
      model: this.modelValue,
    };
  },
  computed: {
    startDate: {
      get() {
        const d = checkDate(this.model?.startDate);
        return d ? d.toISOString() : null;
      },
      set(d) {
        d = checkDate(d);
        if (d) {
          this.model.startDate = d;
        } else {
          this.model.startDate = undefined;
        }
      },
    },
    endDate: {
      get() {
        const d = checkDate(this.model?.endDate);
        return d ? d.toISOString() : null;
      },
      set(d) {
        d = checkDate(d);
        if (d) {
          this.model.endDate = d;
        } else {
          this.model.endDate = undefined;
        }
      },
    },
  },
  watch: {
    model(m) {
      this.$emit("update:modelValue", m);
    },
    modelValue(m) {
      this.model = m;
    },
  },
};
</script>
<style lang="scss" scoped>
.cell {
  display: flex;
  min-width: 150px;

  & > div {
    flex: 1;
  }

  label {
    display: block;
    font-size: 0.8em;
    margin-bottom: 0.3em;
    text-transform: uppercase;
    font-weight: 500;
    opacity: 0.5;
  }
}
</style>
